import { render } from "./AccountingTemplatesList.vue?vue&type=template&id=0937ba51&scoped=true"
import script from "./AccountingTemplatesList.vue?vue&type=script&lang=js"
export * from "./AccountingTemplatesList.vue?vue&type=script&lang=js"

import "./AccountingTemplatesList.vue?vue&type=style&index=0&id=0937ba51&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0937ba51"]])

export default __exports__